<template>
    <div class="autocomplete-tag" :class="{'result': searchTags &&searchTags.length}">
        <div class="grid xs-grid-cols-1">
            <div class="input right" v-if="!isRentalFilter">
                <input ref="input" type="text" v-model="searchText" :placeholder="options.placeholder" autocomplete="off"/>
                <button type="button" v-if="searchText" @click="reset">
                    <i class="icon-times"></i>
                </button>
                <i v-else class="icon-search"></i>
            </div>
            <div class="autocomplete-tag-list" v-if="searchTags && searchTags.length">
                <ul>
                    <li :class="{hover:index===i}" v-for="(tag,i) in searchTags" :key="'s-' + tag + '-' + i">
                        <button type="button" @click='toggle(tag)'>
                            <i :class="_value && _value.length && _value.indexOf(tag) >= 0 ? 'icon-check-square' : 'icon-square'"></i> {{getTags[tag] || tag.replace(/_/g, ' ')}}
                        </button>
                    </li>
                </ul>
            </div>
            <div class="grid xs-grid-cols-1 sm-grid-cols-2 gap-1 autocomplete-tag-list-fixed">
                <template  v-if="_value && _value.length">
                    <button type="button" class="singleline text-left"  v-for="item in _value" :key="'v-' + item" @click="remove(item)">
                        <i class="icon-check-square"></i>
                        <span>{{ chipDisplayLabel(item) }}</span>
                    </button>
                </template>

                <button type="button" class="singleline text-left"  @click="toggle(tag)" v-for="tag in getDefaultTags" :key="'d-' + tag">
                    <i :class="_value && _value.length && _value.indexOf(tag) >= 0 ? 'icon-check-square' : 'icon-square'"></i>
                    <span>{{ chipDisplayLabel(tag) }}</span>
                </button>
            </div>
        </div>
    </div>
</template>
<script src="./mvt-autocompletetag.js"></script>

<style lang="scss">
@use "./mvt-autocompletetag.scss" as *;
</style>
